import * as React from 'react';
import { SVGProps } from 'react';

const IconBitSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.5 2h-5v1.25H2.25v3.722L1 7.616C1 8.656 1.844 9.5 2.884 9.5h.29l.326-.653h1.25l.327.653h1.846l.327-.653H8.5l.327.653h.289C10.156 9.5 11 8.656 11 7.616l-1.25-.644V3.25H8.5V2Z" />
  </svg>
);
export default IconBitSizeXs;
